// modules
import { createAction } from 'redux-actions'

// actions
export const setCarePlanReportList = createAction('SET_REPORT_CARE_PLAN_LIST')

export const resetCarePlanReport = createAction('RESET_REPORT_CARE_PLAN')
